<template>
  <div class="tw:h-screen tw:w-screen tw:flex tw:flex-col tw:items-center tw:justify-center">
    <img src="/logo.png" />
    
    <TextPlay class="tw:mt-5" weight="semibold" size="xl" :text="$t('maintenance_page.title')" />
    <TextPlay :text="'Estaremos de volta em breve!'" />
  </div>
</template>
